import React from 'react';
import { useField } from 'formik';

interface Props {
  name: string;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  resize?: boolean;
  textAreaClassName?: string;
  scrollable?: boolean;
}

const TextArea: React.FC<Props> = ({
  label,
  name,
  placeholder,
  disabled = false,
  className,
  textAreaClassName,
  scrollable,
}) => {
  const [field, meta] = useField(name);
  const hasError = meta.touched && meta.error;
  return (
    <div className={`${className} form__form-group`}>
      {label && <span className="form__form-group-label">{label}</span>}
      <div className="form__form-group-field">
        <div className="form__form-group-input-wrap">
          <textarea
            {...field}
            placeholder={placeholder}
            disabled={disabled}
            className={`resize-v ${hasError ? 'error' : ''} ${textAreaClassName || ''}`}
            style={{ overflow: scrollable ? 'auto' : 'hidden' }}
          />
          {hasError && <span className="form__form-group-error">{meta.error}</span>}
        </div>
      </div>
    </div>
  );
};

export default TextArea;
